import classNames from 'classnames';

import { GoalModel } from 'lib/models/goals';
import { setupForDark } from 'lib/theme';

export default function GoalAuthor({ goal, className }: { goal: GoalModel; className?: string }) {
  return (
    <div className={classNames('P3R', setupForDark('text-tertiary'), className)}>
      {goal?.user?.name ?? ''}
    </div>
  );
}
